// components/forms/TranslationIssuesComponent.jsx

import { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import axios from 'axios';
import DataProtectionInformationContactForm from './DataProtectionInformationContactForm';

const TranslationIssuesComponent = () => {
  const { t, i18n } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    language: i18n.language,
    issue: '',
    correction: '',
  });

  const [formSubmitted, setFormSubmitted] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${apiUrl}/translations/send-translation-issue`, formData);
      console.log('Translation issue submitted:', formData);
      setFormSubmitted(true);
    } catch (error) {
      console.error('There was an error submitting the form:', error);
      alert(t('translation_issue_error'));
    }
  };

  return (
    <div>
      {formSubmitted ? (
        <div className="confirmation-message" style={{ textAlign: 'center' }}>
          <h2>{t('thank_you')}</h2>
          <p>{t('your_message_has_been_sent')}</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="web-modal-form">
          <h2 style={{ textAlign: 'center', color: 'var(--green-darkest)' }}>
            {t('help_improve_translations')}
          </h2>
          <p className="web-modal-text-muted" style={{ textAlign: 'center' }}>
            <Trans i18nKey="translation_issues_explanation" />
          </p>

          <label>{t('your_name')}</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="web-modal-input"
          />

          <label>{t('your_email')}</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="web-modal-input"
          />

          <label className="web-modal-text-muted">
            {t('language')}: <strong>{formData.language}</strong>
          </label>

          <label>{t('where_it_says')}</label>
          <textarea
            name="issue"
            value={formData.issue}
            onChange={handleChange}
            required
            className="web-modal-input web-modal-textarea"
            rows="4"
          />

          <label>{t('it_should_say')}</label>
          <textarea
            name="correction"
            value={formData.correction}
            onChange={handleChange}
            required
            className="web-modal-input web-modal-textarea"
            rows="4"
          />

          <DataProtectionInformationContactForm
            formData={formData}
            handleChange={handleChange}
            fontSize="0.8em"
          />

          <button type="submit" className="web-modal-button" style={{ marginTop: '1rem' }}>
            {t('submit')}
          </button>
        </form>
      )}
    </div>
  );
};

export default TranslationIssuesComponent;